import {
  Pipe,
  PipeTransform
} from '@angular/core';
import {IddTrainingCertificate} from '../interface/idd-training-certificate';


@Pipe({
  name: 'orderIddCertificates'
})
export class OrderIddCertificatesPipe implements PipeTransform {


  transform(value: IddTrainingCertificate[]): any {
    return value.sort(
      (a: IddTrainingCertificate, b: IddTrainingCertificate) =>
        new Date(a.realisedAt).getTime() - new Date(b.realisedAt).getTime()
    );
  }
}
